import { render, staticRenderFns } from "./etiquetas.vue?vue&type=template&id=6a42b2af&scoped=true&"
import script from "./etiquetas.vue?vue&type=script&lang=js&"
export * from "./etiquetas.vue?vue&type=script&lang=js&"
import style0 from "./etiquetas.vue?vue&type=style&index=0&id=6a42b2af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42b2af",
  null
  
)

export default component.exports